import axios from 'axios';

const options = {
	// API endpoints are full paths from data attributes, no baseURL needed
	baseURL: ''
}

const instance = axios.create(options);

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		console.log('[AXIOS]', 'RESPONSE', JSON.stringify({ error }));
	    if (error.response?.status !== 401) {
	      	return Promise.reject(error);
	    }
	}
);

instance.interceptors.request.use(
  (config) => {
    try {
      	return config;
    } catch (error) {
       	console.log('[AXIOS]', 'REQUEST', JSON.stringify({ error }));
      	return config;
    }
  },
  (error) => Promise.reject(error),
);

export default instance;